import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const WorldLanguagePilotLink = ({
  children,
  contentType,
  isStudent,
  ...rest
}) => {
  const url = `assessments/world-language-pilot/${contentType}`;

  return (
    <A11y>
      <Link
        data-test-subunit-url
        disabled={!isStudent}
        to={url}
        target="_blank"
        {...rest}
      >
        {children}
      </Link>
    </A11y>
  );
};

WorldLanguagePilotLink.propTypes = {
  url: PropTypes.string.isRequired,
  isSigned: PropTypes.bool,
};

WorldLanguagePilotLink.defaultProps = {
  isSigned: false,
  useClassroomResourceAddress: false,
};

const mapsStateToProps = ({ userData }) => ({
  isStudent: userData.isStudent,
});

export default connect(mapsStateToProps)(WorldLanguagePilotLink);
